import { cn } from '../../lib/utils';

const Void = ({ className }: { className?: string }) => {
  return (
    <span
      className={cn(
        'rounded px-[5px] py-0 bg-red-400 text-white font-bold text-[0.65em]',
        className
      )}
    >
      Void
    </span>
  );
};

export default Void;
